{
  "title": "Restablecer tu contraseña",
  "subtitle": "Ingresa tu correo para recibir un enlace de recuperación",
  "emailLabel": "Correo",
  "sendButton": "Enviar enlace",
  "sendingButton": "Enviando...",
  "backToLogin": "Volver al inicio",
  "successTitle": "Revisa tu correo",
  "successMessage": "Enviamos un enlace de recuperación a",
  "expiryNote": "El enlace expirará en 1 hora",
  "errors": {
    "emailRequired": "Ingresa tu correo electrónico",
    "invalidEmail": "Ingresa una dirección de correo electrónico válida",
    "sendFailed": "No se pudo enviar el correo. Intenta de nuevo."
  }
}
